import React from 'react';
import { styled } from '@mui/material/styles';

const HighlightSpan = styled('span')(({ theme }) => ({
  backgroundColor: theme.palette.warning.light,
  padding: '0 2px',
  borderRadius: '2px',
}));

interface TextHighlightProps {
  text: string;
  highlight: string;
}

const TextHighlight: React.FC<TextHighlightProps> = ({ text, highlight }) => {
  if (!highlight.trim()) {
    return <>{text}</>;
  }

  // Split keywords by newlines and filter out empty lines
  const keywords = highlight.split('\n')
    .map(kw => kw.trim())
    .filter(kw => kw.length > 0);

  if (keywords.length === 0) {
    return <>{text}</>;
  }

  // Escape special regex characters and create a pattern for all keywords
  const escapedKeywords = keywords.map(kw => 
    kw.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  );
  const pattern = `(${escapedKeywords.join('|')})`;
  
  const parts = text.split(new RegExp(pattern, 'gi'));

  return (
    <>
      {parts.map((part, i) => {
        const isMatch = keywords.some(kw => 
          part.toLowerCase() === kw.toLowerCase()
        );
        
        return isMatch ? (
          <HighlightSpan key={i}>{part}</HighlightSpan>
        ) : (
          part
        );
      })}
    </>
  );
};

export default TextHighlight; 